/**
 * Analytics Service
 * Centralized analytics tracking
 */

import { config } from '../config';

class AnalyticsService {
  constructor() {
    this.enabled = config.analytics.enableAnalytics;
    this.isInitialized = false;
  }

  /**
   * Initialize analytics (Google Analytics, etc.)
   */
  init() {
    if (!this.enabled || this.isInitialized) return;

    // Initialize Google Analytics if ID is provided
    if (config.analytics.googleAnalyticsId) {
      this.initGoogleAnalytics();
    }

    this.isInitialized = true;
  }

  /**
   * Initialize Google Analytics
   */
  initGoogleAnalytics() {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${config.analytics.googleAnalyticsId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', config.analytics.googleAnalyticsId);
  }

  /**
   * Track page view
   */
  trackPageView(path, title) {
    if (!this.enabled) return;

    if (window.gtag) {
      window.gtag('config', config.analytics.googleAnalyticsId, {
        page_path: path,
        page_title: title,
      });
    }
  }

  /**
   * Track custom event
   */
  trackEvent(action, category, label, value) {
    if (!this.enabled) return;

    if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    }
  }

  /**
   * Track download action
   */
  trackDownload(platform) {
    this.trackEvent('download', 'app', platform);
  }

  /**
   * Track language change
   */
  trackLanguageChange(language) {
    this.trackEvent('language_change', 'user_preference', language);
  }

  /**
   * Track contact action
   */
  trackContact(method) {
    this.trackEvent('contact', 'engagement', method);
  }
}

// Create and export singleton instance
const analyticsService = new AnalyticsService();
export default analyticsService;